import { Box } from '@mui/material'
import React from 'react'
import Flag from 'react-world-flags'

export enum TimeZoneToPlate {
  'Europe/Amsterdam' = 'NL', // Netherlands
  'Europe/Andorra' = 'AND', // Andorra
  'Europe/Astrakhan' = 'RUS', // Russia
  'Europe/Athens' = 'GR', // Greece
  'Europe/Belfast' = 'GB', // United Kingdom (Northern Ireland)
  'Europe/Belgrade' = 'SRB', // Serbia
  'Europe/Berlin' = 'D', // Germany
  'Europe/Bratislava' = 'SK', // Slovakia
  'Europe/Brussels' = 'B', // Belgium
  'Europe/Bucharest' = 'RO', // Romania
  'Europe/Budapest' = 'H', // Hungary
  'Europe/Busingen' = 'D', // Germany (Büsingen exclave)
  'Europe/Chisinau' = 'MD', // Moldova
  'Europe/Copenhagen' = 'DK', // Denmark
  'Europe/Dublin' = 'IRL', // Ireland
  'Europe/Gibraltar' = 'GBZ', // Gibraltar
  'Europe/Guernsey' = 'GBG', // Guernsey
  'Europe/Helsinki' = 'FIN', // Finland
  'Europe/Isle_of_Man' = 'GBM', // Isle of Man
  'Europe/Istanbul' = 'TR', // Turkey
  'Europe/Jersey' = 'GBJ', // Jersey
  'Europe/Kaliningrad' = 'RUS', // Russia (Kaliningrad)
  'Europe/Kiev' = 'UA', // Ukraine (deprecated spelling)
  'Europe/Kirov' = 'RUS', // Russia
  'Europe/Kyiv' = 'UA', // Ukraine (preferred spelling)
  'Europe/Lisbon' = 'P', // Portugal
  'Europe/Ljubljana' = 'SLO', // Slovenia
  'Europe/London' = 'GB', // United Kingdom
  'Europe/Luxembourg' = 'L', // Luxembourg
  'Europe/Madrid' = 'E', // Spain
  'Europe/Malta' = 'M', // Malta
  'Europe/Mariehamn' = 'AX', // Åland Islands
  'Europe/Minsk' = 'BY', // Belarus
  'Europe/Monaco' = 'MC', // Monaco
  'Europe/Moscow' = 'RUS', // Russia
  'Europe/Nicosia' = 'CY', // Cyprus
  'Europe/Oslo' = 'N', // Norway
  'Europe/Paris' = 'F', // France
  'Europe/Podgorica' = 'MNE', // Montenegro
  'Europe/Prague' = 'CZ', // Czech Republic
  'Europe/Riga' = 'LV', // Latvia
  'Europe/Rome' = 'I', // Italy
  'Europe/Samara' = 'RUS', // Russia
  'Europe/San_Marino' = 'RSM', // San Marino
  'Europe/Sarajevo' = 'BIH', // Bosnia & Herzegovina
  'Europe/Saratov' = 'RUS', // Russia
  'Europe/Simferopol' = 'UA', // Ukraine (Crimea; disputed)
  'Europe/Skopje' = 'MK', // North Macedonia
  'Europe/Sofia' = 'BG', // Bulgaria
  'Europe/Stockholm' = 'S', // Sweden
  'Europe/Tallinn' = 'EST', // Estonia
  'Europe/Tirane' = 'AL', // Albania
  'Europe/Ulyanovsk' = 'RUS', // Russia
  'Europe/Uzhgorod' = 'UA', // Ukraine
  'Europe/Vaduz' = 'FL', // Liechtenstein
  'Europe/Vatican' = 'V', // Vatican City
  'Europe/Vienna' = 'A', // Austria
  'Europe/Vilnius' = 'LT', // Lithuania
  'Europe/Volgograd' = 'RUS', // Russia
  'Europe/Warsaw' = 'PL', // Poland
  'Europe/Zagreb' = 'HR', // Croatia
  'Europe/Zaporozhye' = 'UA', // Ukraine
  'Europe/Zurich' = 'CH', // Switzerland
}

export const EUPlates: string[] = [
  'A', // Austria
  'B', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czechia
  'DK', // Denmark
  'EST', // Estonia
  'FIN', // Finland
  'AX', // Åland Islands (autonomous but part of Finland/EU)
  'F', // France
  'D', // Germany
  'GR', // Greece
  'H', // Hungary
  'IRL', // Ireland
  'I', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'L', // Luxembourg
  'M', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'P', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SLO', // Slovenia
  'E', // Spain
  'S', // Sweden
]

interface NumberPlateProps {
  chars: string
  tz: string
  size?: 'small' | 'medium'
}

const NumberPlate: React.FC<NumberPlateProps> = ({
  chars,
  tz = 'Europe/London',
  size = 'medium',
}) => {
  const countryCode = TimeZoneToPlate[tz as keyof typeof TimeZoneToPlate] || ''
  console.log(size)
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#ffffff',
        border: `${size === 'small' ? '1' : '2'}px solid #000000`,
        borderRadius: '4px',
        fontFamily: 'monospace',
        fontSize: size === 'small' ? '12px' : '18px',
        fontWeight: 'bold',
        color: '#000000',
        letterSpacing: size === 'small' ? '1px' : '2px',
        textTransform: 'uppercase',
        minWidth: size === 'small' ? '90px' : '140px',
        height: size === 'small' ? '28px' : '32px',
        boxShadow: '1px 2px 4px rgba(0, 0, 0, 0.1)',
        position: 'relative',
        paddingLeft: size === 'small' ? '22px' : '24px',
        paddingRight: size === 'small' ? '6px' : '8px',
        paddingTop: size === 'small' ? '4px' : '8px',
        paddingBottom: size === 'small' ? '4px' : '8px',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: `-${size === 'small' ? '1' : '2'}px`,
          top: `-${size === 'small' ? '1' : '2'}px`,
          bottom: `-${size === 'small' ? '1' : '2'}px`,
          width: size === 'small' ? '16px' : '20px',
          backgroundColor: '#003399',
          borderTopLeftRadius: '2px',
          borderBottomLeftRadius: '2px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#ffffff',
          fontSize: size === 'small' ? '8px' : '10px',
          letterSpacing: '-0.5px',
          gap: '0px',
          flexDirection: 'column',
          m: 0,
          pt: size === 'small' ? '4px' : '6px',
        }}
      >
        {EUPlates.includes(countryCode) ? (
          <Flag code={'EU'} height={size === 'small' ? '6px' : '12px'} />
        ) : (
          <Flag
            code={countryCode}
            height={size === 'small' ? '5px' : '8px'}
            fallback={<></>}
          />
        )}
        {countryCode}
      </Box>
      {chars}
    </Box>
  )
}

export default NumberPlate
